import { IDeleteFornecedorUseCase } from "../../../presentation/useCases/delete/delete_fornecedor_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * DeleteFornecedorUseCase
 */

export class DeleteFornecedorUseCase implements IDeleteFornecedorUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async deleteFornecedor(
    idFornecedor: number,
  ): Promise<void> {
    await this.repository.deleteFornecedor(idFornecedor);
  }
}
